
<template>
    <div class="h-screen flex w-full bg-img" id="page-login">
        <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 mx-auto self-center">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                    <div class="flex flex-wrap">
                        <div class="vx-col hidden sm:hidden md:hidden lg:block self-center justify-center items-center lg:w-1/2 ">
                            <img src="@/assets/images/logo/login_banner.png" alt="login" class="mx-auto">
                        </div>
                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 bg-white">
                            <div class="mx-6 pb-5">
                                <div class="flex flex-wrap mt-5 mb-8">
                                    <div class="w-4/5">
                                        <h4><em>My</em> Vila Galé</h4>
                                    </div>
                                    <div class="w-1/5">
                                        <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer float-right">
                                            <span class="cursor-pointer flex i18n-locale"><img class="w-6 h-6" :src="require(`@/assets/images/flags/${$i18n.locale}.png`)" :alt="$i18n.locale" /><span class="hidden sm:block ml-2"></span></span>
                                            <vs-dropdown-menu class="w-50 i18n-dropdown">
                                                <vs-dropdown-item @click="updateLocale('en')"><img class="w-6 h-6 mr-1" src="@/assets/images/flags/en.png" alt="en" /> &nbsp;{{ $t('en') }}</vs-dropdown-item>
                                                <vs-dropdown-item @click="updateLocale('pt')"><img class="w-6 h-6 mr-1" src="@/assets/images/flags/pt.png" alt="pt" /> &nbsp;{{ $t('pt') }}</vs-dropdown-item>
                                                <vs-dropdown-item @click="updateLocale('br')"><img class="w-6 h-6 mr-1" src="@/assets/images/flags/br.png" alt="br" /> &nbsp;{{ $t('br') }}</vs-dropdown-item>
                                                <vs-dropdown-item @click="updateLocale('de')"><img class="w-6 h-6 mr-1" src="@/assets/images/flags/de.png" alt="de" /> &nbsp;{{ $t('de') }}</vs-dropdown-item>
                                                <vs-dropdown-item @click="updateLocale('fr')"><img class="w-6 h-6 mr-1" src="@/assets/images/flags/fr.png" alt="fr" /> &nbsp;{{ $t('fr') }}</vs-dropdown-item>
                                                <vs-dropdown-item @click="updateLocale('es')"><img class="w-6 h-6 mr-1" src="@/assets/images/flags/es.png" alt="es" /> &nbsp;{{ $t('es') }}</vs-dropdown-item>
                                            </vs-dropdown-menu>
                                        </vs-dropdown>
                                    </div>
                                </div>
                                <vs-input
                                    v-validate="'required'"
                                    :danger="emailInput"
                                    danger-text="Email Invalido"
                                    name="user"
                                    icon="icon icon-user"
                                    icon-pack="feather"
                                    :label-placeholder="$t('user_email')"
                                    v-model="user"
                                    class="w-full no-icon-border"/>
                                <vs-input
                                    v-validate="'required'"
                                    type="password"
                                    name="password"
                                    icon="icon icon-lock"
                                    icon-pack="feather"
                                    :label-placeholder="$t('password')"
                                    v-model="password"
                                    class="w-full mt-6 no-icon-border" />
                                <div align="right" class="mt-5">
                                    <a :href="clube_url+'/login?recover'" target="_blank">
                                        {{ $t('revocerPassword') }}
                                    </a>
                                </div>
                                <div class="mt-5">
                                    <vs-button v-on:click="openLink(clube_url)" type="border">{{ $t('register') }}</vs-button>
                                    <vs-button class="float-right" @click="toLogin(user, password)" @keyup.enter.native="toLogin(user, password)">Login</vs-button>
                                </div>
                                <div class="mt-5">
                                    <p class="text-right">
                                        <span v-html="$t('check_cartas_login')"></span>
                                        <router-link :to="{name: 'public-menu'}"> {{$t('here')}}</router-link>.
                                    </p>
                                </div>
                                <div class="mt-5">
                                    <p class="text-right">
                                        <span v-html="$t('check_entertainment_login')"></span>
                                        <router-link :to="{name: 'public-entertainment'}"> {{$t('here')}}</router-link>.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>
<script>
//load configurations on theme
import themeConfig from '@/../themeConfig.js';
// import axios
import axios from 'axios';  
export default {
    data() {
        return {
            user: '',
            password: '',
            login_error: false,
            emailInput: false,
            badCredentials: false,
            flag_login: true,
            loggin_attempts: 0,
            clube_url: process.env.VUE_APP_CLUBE_URL,
        }
    },
    methods: {
        isEmail(email) {
            let re = /\S+@\S+\.\S+/;
            return re.test(email);
        },
        openLink (link) {   
            window.open(link, "_blank");    
        },
        toLogin(user, password) {
            if(!this.flag_login) {
                return;
            }
            if (user == '' && password == '') {
                this.$vs.notify({
                    text: this.$t('login_password'),
                    color:'danger',
                    position:'bottom-right',
                    iconPack: 'feather',
                    icon:'icon-alert-triangle'
                });
                return false;
            }
            if (user == '') {
                this.$vs.notify({
                    text: this.$t('mandatory_user'),
                    color:'danger',
                    position:'bottom-right',
                    iconPack: 'feather',
                    icon:'icon-alert-triangle'
                });
                return false;
            }
            if (password == '') {
                this.$vs.notify({
                    text: this.$t('mandatory_password'),
                    color:'danger',
                    position:'bottom-right',
                    iconPack: 'feather',
                    icon:'icon-alert-triangle'
                });
                return false;
            }
            user = user.trim();
            this.$vs.loading();
            this.login_error = false;
            this.flag_login = false;
            let md5 = require("md5");
            let payload = {
                password: md5(password),
                noEncrypted: false
            };
            if(this.isEmail(user))
                payload.email = user;
            else
                payload.login = user;
            let that = this;
            // login on API
            axios({
                method: 'post',
                url: themeConfig.apiurl + '/auth/login',
                data: payload,
                headers: {
                    Authorization: 'Bearer ' +process.env.VUE_APP_TOKEN
                }
            })
            .then(function (response) {
        
                // hide error message   
                that.badCredentials = false;
            
                // session in javascript to store login information (token)
                window.localStorage.setItem('usertoken', response.data.token);
                axios({
                    method: 'get',
                    url: themeConfig.apiurl + '/myvilagale/user/info',
                    params: {
                        token: response.data.token,
                        login: user,
                        pass: password
                    },
                    headers: {
                        Authorization: 'Bearer ' + response.data.token
                    }
                })
                .then(function (res) {
                    that.login_error = false;
                    let booking_list = res.data.bookingList.map(function(item, index){
                        item.label = item.num_reserva + ' | ' + item.hotel.hvg_desc;
                        item.current_data_check_in = item.current_data_check_in.split(' ')[0];
                        item.current_data_check_out = item.current_data_check_out.split(' ')[0];
                        return item;
                    });
                    //create object user with data from return db
                    let user = {
                        id: res.data.id,
                        name: res.data.name,
                        email: res.data.email,
                        md5: res.data.md5,
                        is_staff: res.data.is_staff,
                        username: res.data.username.login,
                        login: res.data.login,
                        gender: res.data.sex_id,
                        usertoken: response.data.token,
                        role: res.data.staff_info.role_id ? res.data.staff_info.role_id : 1,
                        hotel: res.data.hotel,
                        future_rsv: res.data.future_rsv,
                        is_staff: res.data.is_staff,
                        staff_info: res.data.staff_info ? res.data.staff_info : [],
                        time: new Date().getTime(),
                        bookingList: booking_list,
                        payments_available: res.data.payments_available,
                        forceLoginChange: res.data.forceLoginChange
                    }
                    that.$vs.loading.close();

                    localStorage.setItem('userSession', JSON.stringify(user));

                    //create session obbject with an object user
                    that.$user = user;

                    if(!window.localStorage.getItem('hidePopup')) {
                        window.localStorage.setItem('hidePopup', true);
                    }

                    // force to redirect to change the password
                    if(res.data.forceLoginChange == 1){
                        that.$router.push({name: 'newpassword'});
                        return;
                    }

                    if(typeof that.$route.query.redirect !== 'undefined') {
                        // CHECK IF ROUTE EXISTS
                        let l = that.$router.resolve({name: that.$route.query.redirect});
                        if(l.resolved.matched.length > 0){
                            that.$router.push({name: that.$route.query.redirect})
                            return;
                        }
                    }

                    that.$router.push('/');
                    
                })
                .catch( function (err) {
                    that.flag_login = true;
                    that.$vs.loading.close();
                })
            })
            .catch(function (error) {
                that.flag_login = true;
                that.$vs.loading.close();
                that.login_error = true;
                that.badCredentialsMessage=error.response.data.error;
                that.notify(that.$t(error.response.data.message), 'red', 10);
                that.badCredentials = true;
                that.login_error++;
            });
        },
    },
    computed: {
        
    },
    created() {
        if(this.$user !== null) {
            if(this.$user.forceLoginChange != 1){
                this.$router.push('/'); 
            }
        }
        // history.pushState({}, document.title, window.location.href.split('?')[0]); // remove ?redirect=2F% from url
        window.addEventListener('keydown', (e) => {
            if (e.key == 'Enter') {
                this.toLogin(this.user, this.password);
            }
        });
    }
}
</script>
<style lang="scss">
#page-login {
    .social-login {
        .bg-facebook {
          background-color: #1551b1;
        }
        .bg-twitter {
          background-color: #00aaff;
        }
        .bg-google {
          background-color: #1551b1;
        }
        .bg-github {
          background-color: #333;
        }
    }
}
</style>